module.exports = __webpack_public_path__ + "static/media/light_logo_r.f4607ec9.png";